export default __webpack_public_path__ + "static/media/file-lines.a7e7018f.svg";